module.exports = "https://bin.bnbstatic.com/_next/static/images/multiFait-04bd1eb170e600cae2def6a0ed0d0968.png";